export const decryptPDF = async (encryptedData, keyBase64, ivBase64) => {
  if (!window.crypto || !window.crypto.subtle) {
    // 🆕 پیام واضح‌تر و بررسی context
    const isFileProtocol = typeof window !== 'undefined' && window.location.protocol === 'file:';
    const errorMsg = isFileProtocol
      ? 'مرورگر شما از رمزگشایی امن پشتیبانی نمی‌کند. لطفاً از نسخه وب استفاده کنید یا با پشتیبانی تماس بگیرید.'
      : 'Web Crypto API در دسترس نیست. لطفاً از HTTPS استفاده کنید.';
    console.error('❌ Web Crypto unavailable:', { protocol: window.location.protocol });
    throw new Error(errorMsg);
  }


  const keyBytes = Uint8Array.from(atob(keyBase64), c => c.charCodeAt(0));
  const ivBytes = Uint8Array.from(atob(ivBase64), c => c.charCodeAt(0));

  // آخرین ۱۶ بایت = auth tag
  const tagLength = 16;
  const ciphertext = encryptedData.slice(0, encryptedData.byteLength - tagLength);
  const tag = encryptedData.slice(encryptedData.byteLength - tagLength);

  // ترکیب ciphertext + tag
  const combined = new Uint8Array(ciphertext.byteLength + tag.byteLength);
  combined.set(new Uint8Array(ciphertext), 0);
  combined.set(new Uint8Array(tag), ciphertext.byteLength);

  const cryptoKey = await crypto.subtle.importKey(
    'raw', keyBytes,
    { name: 'AES-GCM' },
    false, ['decrypt']
  );

  const decrypted = await crypto.subtle.decrypt(
    { name: 'AES-GCM', iv: ivBytes, tagLength: 128 },
    cryptoKey,
    combined
  );

  return decrypted;
};